import React, { useContext } from "react";
import LoadingBar from "react-top-loading-bar";
import loaderContext from "../../context/loader/LoaderContext";

// const TopLoader = ({ progress, setProgress, setProgressComplete }) => {
const TopLoader = () => {
  // const changeProgress = () => {
  //     setProgress(0);
  //     setProgressComplete(true);
  //   };

  const { ref, setLoaderRunning, loaderRunning, loaderAnnotationRunning, setLoaderAnnotationRunning } = useContext(loaderContext);

  return (
    <div
      style={{
        padding: "auto",
        height: "100%",
        width: "100%",
        zIndex: "999999999999",
        display: `${loaderRunning ? "flex" : "none"}`,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
        opacity: `${loaderAnnotationRunning ? "0" : "0.8"}`,
        position: "absolute",
        top: "0",
        left: "0",
      }}
    >
      <LoadingBar
        ref={ref}
        color="#0085FF"
        height={5}
        // progress={progress}
        onLoaderFinished={() => {        
          if(loaderRunning){
            setLoaderRunning(false);
          }
        }}
        containerStyle={{
          backgroundColor: "black",
          opacity: "0.8",
          position: "absolute",
          top: "0",
          left: "0",
        }}
        loaderSpeed={1000}
        transitionTime={1000}
      />
      {/* <div
        style={{
          color: "white",
          position: "absolute",
          top: "50%",
          width: "100%",
          textAlign: "center",
        }}
      >
        <h1>SAMPLE TEXT</h1>
      </div> */}
    </div>
  );
};

export default TopLoader;
